<template>
	<dashboard-panel
		title="Statistics"
		:edit-mode="editMode"
		popout-url="/app/stats.html"
		:popout-width="760"
		:popout-height="480"
		@remove="$emit('remove')"
	>
		<stats-view />
	</dashboard-panel>
</template>

<script>
import DashboardPanel from '../DashboardPanel.vue';
import StatsView from '../StatsView.vue';

export default {
	name: 'StatsPanel',
	components: { DashboardPanel, StatsView },
	props: {
		editMode: { type: Boolean, default: false },
	},
};
</script>
